import $http from "../../axios-instance";
import Swal from "sweetalert2";

/**
 * Cargar las listas.
 *
 * @param {*} commit
 * @return {Promise<void>}
 * @author Fernando CLaros Garcia
 */
export async function loadCountries({ commit }) {
    commit("dashboard/load", true, { root: true });

    await $http
        .get("countries/get-all")
        .then(({ data: response, status }) => {
            if (status === 200) {
                commit("setCountries", response.payload);
                return;
            }

            callbackGenerateAlert("info", response.message, true);
        })
        .catch(() =>
            callbackGenerateAlert(
                "error",
                "Error al tratar de cargar el Listado de países."
            )
        )
        .finally(() => commit("dashboard/load", false, { root: true }));
}

/**
 * Generar alarta.
 *
 * @param String icon: (info, success, error)
 * @param String text
 * @param Boolean showConfirmButton
 * @author Fernando CLaros Garcia
 */
function callbackGenerateAlert(
    icon = "info",
    text = "",
    showConfirmButton = false
) {
    Swal.fire({
        position: "center",
        icon,
        title: "Variables configurables",
        text,
        showConfirmButton,
    });
}

/**
 * Listar los países con sus empresas.
 * @param {*} company_id
 */
export async function getCountriesToCompanyId({ commit }, company_id) {
    commit("dashboard/load", true, { root: true });

    try {
        const response = await $http.get(
            `countries/all-with-enterprises?company_id=${company_id}`
        );

        commit("setCountriesWithEnterprises", response.data.data);
        commit("dashboard/load", false, { root: true });
    } catch (error) {
        callbackGenerateAlert(
            "error",
            "Error al tratar de cargar el Listado de países."
        );
        commit("dashboard/load", false, { root: true });
    }
}

/**
 * Obtener un país por su id y el id de la empresa y sus enterprises.
 * @param {*} country_id
 * @param {*} company_id
 */
export async function getCountryByIdAndCompanyId(
    { commit },
    { country_id, company_id }
) {
    commit("dashboard/load", true, { root: true });

    try {
        const response = await $http.get(
            `countries/by-id-with-enterprises/${country_id}?company_id=${company_id}`
        );

        commit("enterprises/setEnterprises", response.data.data.enterprises, {
            root: true,
        });
        commit("dashboard/load", false, { root: true });
    } catch (error) {
        callbackGenerateAlert(
            "error",
            "Error al tratar de cargar el Listado de países."
        );
        commit("dashboard/load", false, { root: true });
    }
}

/**
 * Listar los países con sus códigos telefónicos.
 */
export async function getCountriesWithPhoneCodes({ commit }) {
    commit("dashboard/load", true, { root: true });

    try {
        const response = await $http.get("countries/all-with-phone-codes");

        commit("setCountriesWithPhoneCodes", response.data.data);
        commit("dashboard/load", false, { root: true });
    } catch (error) {
        callbackGenerateAlert(
            "error",
            "Error al tratar de cargar el Listado de países."
        );
        commit("dashboard/load", false, { root: true });
    }
}
